import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { BaseService } from './base-service.service';
import { Observable, catchError, of } from 'rxjs';
import { SelectListItemValue } from '../models/selectListItem';
import { ApiResponse } from '../models/api-response.model';
import { LookupBase, LookupItemModel, LookupModel } from '../models/lookup.base.model';

@Injectable({
  providedIn: 'root',
})
export class LookupsService extends BaseService {
  private _lookups: Array<{ key: string, lookups: ApiResponse<Array<LookupBase>> }> = []
  constructor(private http: HttpClient) {
    super();
  }
  getHostingPlacesList(): Observable<ApiResponse<SelectListItemValue[]>> {
    return this.http.get<ApiResponse<SelectListItemValue[]>>(`/api/lookups/hosting-places/`
    ).pipe(catchError(this.handleError));
  }

  getNationalitiesList(): Observable<ApiResponse<SelectListItemValue[]>> {
    return this.http.get<ApiResponse<SelectListItemValue[]>>(`/api/lookups/nationalities/`
    ).pipe(catchError(this.handleError));
  }

  getStoreItemsList(): Observable<ApiResponse<SelectListItemValue[]>> {
    return this.http.get<ApiResponse<SelectListItemValue[]>>(`/api/lookups/store-items/`
    ).pipe(catchError(this.handleError));
  }

  getAllowPeriodsList(): Observable<ApiResponse<SelectListItemValue[]>> {
    return this.http.get<ApiResponse<SelectListItemValue[]>>(`/api/lookups/allow-periods/`
    ).pipe(catchError(this.handleError));
  }
  getWeightMethods(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetWeightMethods`);
  }
  
  getRequestStatus(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetRequestStatus`);
  }
  getEmirates(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetEmirates`);
  }
  getRequestTypes(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetRequestTypes`);
  }
  getIndexTypes(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetIndexTypes`);
  }
  getQuestionTypes(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetQuestionypes`);
  }
  getAnswerTypes(): Observable<ApiResponse<Array<LookupBase>>> {
    return this.getLookup(`/api/lookups/GetAnswerTypes`);
  }
  
  getLegalTypes(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetLegalTypes/`
    ).pipe(catchError(this.handleError));
  }

  getEmployeeTypes(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetEmployeeTypes/`
    ).pipe(catchError(this.handleError));
  }

  getLicenseTypes(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetLicenseTypes/`
    ).pipe(catchError(this.handleError));
  }
  getRequestStatuses(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetLicenseTypess/`
    ).pipe(catchError(this.handleError));
  }

  deleteRequestStatus(id:any): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`/api/lookups/DeleteRequestStatus?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  deleteLicenseType(id:any): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`/api/lookups/DeleteLicenseType?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  deleteEmployeeType(id:any): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`/api/lookups/DeleteEmployeeType?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  deleteLegalType(id:any): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`/api/lookups/DeleteLegalType?Id=`+id
    ).pipe(catchError(this.handleError));
  }
getRequestStatusById(id:any): Observable<ApiResponse<LookupItemModel>> {
    return this.http.get<ApiResponse<LookupItemModel>>(`/api/lookups/GetRequestStatusById?Id=`+id
    ).pipe(catchError(this.handleError));
  }

  getCompanyCategories(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetCompanyCategories/`
    ).pipe(catchError(this.handleError));
  }
  deleteCompanyCategory(id:any): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`/api/lookups/DeleteCompanyCategory?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  getCompanyCategoryById(id:any): Observable<ApiResponse<LookupItemModel>> {
    return this.http.get<ApiResponse<LookupItemModel>>(`/api/lookups/GetCompanyCategoryById?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  AddCompanyCategoryLookup(post: any): Observable<any> {
    return this.http.post<any>('/api/lookups/AddCompanyCategoryLookup', post);
  }



  getLaborCardTypes(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetLaborCardTypes/`
    ).pipe(catchError(this.handleError));
  }
  deleteLaborCardType(id:any): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`/api/lookups/DeleteLaborCardType?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  getLaborCardTypeById(id:any): Observable<ApiResponse<LookupItemModel>> {
    return this.http.get<ApiResponse<LookupItemModel>>(`/api/lookups/GetLaborCardTypeById?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  AddLaborCardTypeLookup(post: any): Observable<any> {
    return this.http.post<any>('/api/lookups/AddLaborCardTypeLookup', post);
  }




  getLegalTypeById(id:any): Observable<ApiResponse<LookupItemModel>> {
    return this.http.get<ApiResponse<LookupItemModel>>(`/api/lookups/GetLegalTypeById?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  getEmployeeTypeById(id:any): Observable<ApiResponse<LookupItemModel>> {
    return this.http.get<ApiResponse<LookupItemModel>>(`/api/lookups/GetEmployeeTypeById?Id=`+id
    ).pipe(catchError(this.handleError));
  }
  getLicenseTypeById(id:any): Observable<ApiResponse<LookupItemModel>> {
    return this.http.get<ApiResponse<LookupItemModel>>(`/api/lookups/GetLicenseTypeById?Id=`+id
    ).pipe(catchError(this.handleError));
  }

  
  AddEmployeeTypeLookup(post: any): Observable<any> {
    return this.http.post<any>('/api/lookups/AddEmployeeTypeLookup', post);
  }
  AddLicenseTypeLookup(post: any): Observable<any> {
    return this.http.post<any>('/api/lookups/AddLicenseTypeLookup', post);
  }
  AddLegalTypeLookup(post: any): Observable<any> {
    return this.http.post<any>('/api/lookups/AddLegalTypeLookup', post);
  }
  AddRequestStatusLookup(post: any): Observable<any> {
    return this.http.post<any>('/api/lookups/AddRequestStatusLookup', post);
  }
  getUserTypes(): Observable<ApiResponse<LookupBase[]>> {
    return this.http.get<ApiResponse<LookupBase[]>>(`/api/lookups/GetUserTypes/`
    ).pipe(catchError(this.handleError));
  }
  getAllRoles(roleId?:number): Observable<ApiResponse<LookupModel[]>> {
    return this.http.get<ApiResponse<LookupModel[]>>(`/api/Lookups/GetRoles/`
    ).pipe(catchError(this.handleError));
  }
  getSurveyTakerAgeRange(): Observable<LookupModel[]> {
    return this.http.get<LookupModel[]>(`/api/lookups/GetSurveyTakerAgeRange/`
    ).pipe(catchError(this.handleError));
  }
  GetSurveyTakerArea(): Observable<LookupModel[]> {
    return this.http.get<LookupModel[]>(`/api/lookups/GetSurveyTakerArea/`
    ).pipe(catchError(this.handleError));
  }
  GetSurveyTakerEducationLevel(): Observable<LookupModel[]> {
    return this.http.get<LookupModel[]>(`/api/lookups/GetSurveyTakerEducationLevel/`
    ).pipe(catchError(this.handleError));
  }
  GetSurveyTakerGender(): Observable<LookupModel[]> {
    return this.http.get<LookupModel[]>(`/api/lookups/GetSurveyTakerGender/`
    ).pipe(catchError(this.handleError));
  }
  getLevels(): Observable<any> {
    return this.http.get<any>(`/api/lookups/GetSurveyTakerGender/`
    ).pipe(catchError(this.handleError));
  }
  getLookup(url: string): Observable<ApiResponse<Array<LookupBase>>> {
    let value = this._lookups.find(l => l.key == url)

    if (value)
      return of(value.lookups);
    return this.http.get<ApiResponse<Array<LookupBase>>>(url);
  }
  saveLookup(key: string, lookups: ApiResponse<Array<LookupBase>>) {
    this._lookups.push({ key, lookups })
  }
  
}
